import React from "react";

const CloseIcon = (props) => {
	return (
		<svg
			width="34"
			height="34"
			viewBox="0 0 34 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<rect
				x="1.5"
				y="1.5"
				width="31"
				height="31"
				rx="15.5"
				stroke="#A0A3BD"
			/>
			<path
				d="M12 12L22.6452 22.6452"
				stroke="#A0A3BD"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12 22.6445L22.6452 11.9994"
				stroke="#A0A3BD"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export default CloseIcon;
